<template>
    <div class="row">
        <div class="col-md-9">
            <b-alert :show="noGradingScale" variant="light">
                <div v-html="noGradingScale"></div>
            </b-alert>
            <div class="table-responsive p-0">
                <table class="table table-bordered">
                    <thead v-if="fpGrades && fpGrades.length">
                        <tr class="bg-light text-center">
                            <td colspan="9">
                                <h5>{{ $t("form.student.foundationGrades") }}</h5>
                            </td>
                        </tr>
                        <tr>
                            <th>{{ $t("form.student.course") }}</th>
                            <th>{{ $t("form.student.percentage") }}</th>
                            <th v-if="showLocalGrades" style="min-width: 90px">{{ localGradeLabel }} </th>
                            <th style="min-width: 90px">{{ $t("form.student.grade") }}</th>
                            <th>{{ $t("form.student.descGrade") }}</th>
                            <th>{{ $t("form.student.finalExam") }}</th>
                            <th v-if="foundationProgram.ProgramCode == 'DBA' || foundationProgram.ProgramType == 'CAP Program'">
                                {{ $t("form.student.sbsCredits") }}</th>
                            <th v-else>{{ $t("form.student.ectsCredits") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">{{ $t("form.student.enroll") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">{{ $t("form.student.deductibleCredits") }}</th>
                            <th>{{ $t("form.student.action") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(line, index) in $v.fpGrades.$each.$iter" v-bind:key="index">
                            <td>{{ fpGrades[index].FullTitle }}</td>
                            <td>
                                <div class="form-group">
                                    <input :readonly="fpGrades[index].isNew == undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " @keyup="
                                            applyFpGradingScale(fpGrades[index])
                                            " type="text" class="form-control" v-model.trim="line.Percentage.$model"
                                        :class="{
                                            'is-invalid':
                                                line.Percentage.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.Percentage.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.Percentage.$params
                                                    .between.min,
                                                num2: line.Percentage.$params
                                                    .between.max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td v-if="showLocalGrades">
                                <div class="form-group">
                                    <input type="text" :readonly="fpGrades[index].isNew == undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " class="form-control"
                                        @keyup="applyFpFinalExam(fpGrades[index], partnerCode, fpCheck)"
                                        v-model.trim="line.LocalGrade.$model" :class="{
                                            'is-invalid':
                                                line.LocalGrade.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.LocalGrade.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.LocalGrade.$params
                                                    .between.min,
                                                num2: line.LocalGrade.$params
                                                    .between.max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <input type="text" :readonly="fpGrades[index].isNew == undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " class="form-control" @keyup="calculateFpGPA()"
                                        v-model.trim="line.Grade.$model" :class="{
                                            'is-invalid': line.Grade.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.Grade.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.Grade.$params.between
                                                    .min,
                                                num2: line.Grade.$params.between
                                                    .max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <select :disabled="fpGrades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " v-model="fpGrades[index].DescriptiveGrade" class="form-control">
                                    <option v-for="(
descriptiveGrade, index
                                        ) in descriptiveGrades" v-bind:key="index" :value="descriptiveGrade">
                                        {{ descriptiveGrade }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <date-picker :lang="lang" :disabled="fpGrades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " class="date-picker" v-model="fpGrades[index].FinalExameDate" valueType="format"
                                    :format="dateFormat" :popup-style="{ top: '100%', left: 0 }"
                                    :append-to-body="false">
                                </date-picker>
                            </td>
                            <td
                                v-if="foundationProgram.ProgramCode == 'DBA' || foundationProgram.ProgramType == 'CAP Program'">
                                <input disabled type="text" class="form-control"
                                    :value="fpGrades[index].isNew ? fpGrades[index].SBSCredits : getSBSCreditsFoundationProgram(fpGrades[index].FullTitle)" />
                            </td>
                            <td v-else>
                                <input disabled type="text" class="form-control"
                                    :value="fpGrades[index].isNew ? fpGrades[index].ECTSCredits : getECTSCreditsFoundationProgram(fpGrades[index].FullTitle)" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                                <input :disabled="fpGrades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " type="checkbox" v-model="fpGrades[index].Enrolled" @change="changeCheck($event)"
                                    value="0" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                                <input type="checkbox" v-model="fpGrades[index].deductibleCredits"
                                    @change="changeCreditCheck($event)" :value="fpGrades[index].deductibleCredits" />
                            </td>
                            <td>
                                <button type="button" :disabled="fpGrades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " class="btn btn-danger text-white btn-sm" @click="removeFpGrade(index)">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="fpGrades.length">
                            <td v-if="showLocalGrades" colspan="7" style="text-align: end;">
                                <strong
                                    v-if="foundationProgram.ProgramCode == 'DBA' || foundationProgram.ProgramType == 'CAP Program'">Total
                                    SBS Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{
                                        totalCreditsFoundationProgram }}
                            </td>
                            <td v-else colspan="6" style="text-align: end;">
                                <strong
                                    v-if="foundationProgram.ProgramCode == 'DBA' || foundationProgram.ProgramType == 'CAP Program'">Total
                                    SBS Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{
                                        totalCreditsFoundationProgram }}
                            </td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr v-if="secondaryGrades.length || foundationGrades" class="bg-light text-center">
                            <td colspan="9">
                                <h5>{{ $t("form.student.primaryGrades") }}</h5>
                            </td>
                        </tr>
                        <tr>
                            <th>{{ $t("form.student.course") }}</th>
                            <th>{{ $t("form.student.percentage") }}</th>
                            <th v-if="showLocalGrades" style="min-width: 90px">{{ localGradeLabel }} </th>
                            <th style="min-width: 90px">{{ $t("form.student.grade") }}</th>
                            <th>{{ $t("form.student.descGrade") }}</th>
                            <th>{{ $t("form.student.finalExam") }}</th>
                            <th v-if="selectedProgramCode == 'DBA' || program1Type == 'CAP Program'">{{
                                $t("form.student.sbsCredits") }}</th>
                            <th v-else>{{ $t("form.student.ectsCredits") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">{{ $t("form.student.enroll") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">{{ $t("form.student.deductibleCredits") }}</th>
                            <th>{{ $t("form.student.action") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(line, index) in $v.grades.$each.$iter" v-bind:key="index">
                            <td>{{ grades[index].FullTitle }}</td>
                            <td>
                                <div class="form-group">
                                    <input :readonly="grades[index].isNew == undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " @keyup="
                                            applyGradingScale(grades[index])
                                            " type="text" class="form-control" v-model.trim="line.Percentage.$model"
                                        :class="{
                                            'is-invalid':
                                                line.Percentage.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.Percentage.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.Percentage.$params
                                                    .between.min,
                                                num2: line.Percentage.$params
                                                    .between.max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td v-if="showLocalGrades">
                                <div class="form-group">
                                    <input type="text" :readonly="grades[index].isNew == undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " class="form-control"
                                        @keyup="applyFinalExam(grades[index], partnerCode, check)"
                                        v-model.trim="line.LocalGrade.$model" :class="{
                                            'is-invalid':
                                                line.LocalGrade.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.LocalGrade.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.LocalGrade.$params
                                                    .between.min,
                                                num2: line.LocalGrade.$params
                                                    .between.max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <input type="text" :readonly="grades[index].isNew == undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " class="form-control" @keyup="calculateGPA()" v-model.trim="line.Grade.$model"
                                        :class="{
                                            'is-invalid': line.Grade.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.Grade.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.Grade.$params.between
                                                    .min,
                                                num2: line.Grade.$params.between
                                                    .max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <select :disabled="grades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " v-model="grades[index].DescriptiveGrade" class="form-control">
                                    <option v-for="(
descriptiveGrade, index
                                        ) in descriptiveGrades" v-bind:key="index" :value="descriptiveGrade">
                                        {{ descriptiveGrade }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <date-picker :lang="lang" :disabled="grades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " class="date-picker" v-model="grades[index].FinalExameDate" valueType="format"
                                    :format="dateFormat" :popup-style="{ top: '100%', left: 0 }"
                                    :append-to-body="false">
                                </date-picker>
                            </td>
                            <td v-if="selectedProgramCode == 'DBA' || program1Type == 'CAP Program'">
                                <input disabled type="text" class="form-control"
                                    :value="grades[index].isNew ? grades[index].SBSCredits : getSBSCreditsProgram1(grades[index].FullTitle)" />
                            </td>
                            <td v-else>
                                <input disabled type="text" class="form-control"
                                    :value="grades[index].isNew ? grades[index].ECTSCredits : getECTSCreditsProgram1(grades[index].FullTitle)" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                                <input :disabled="grades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " type="checkbox" v-model="grades[index].Enrolled" @change="changeCheck($event)"
                                    value="0" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                                <input type="checkbox" v-model="grades[index].deductibleCredits"
                                    @change="changeCreditCheck($event)" :value="grades[index].deductibleCredits" />
                            </td>
                            <td>
                                <button type="button" :disabled="grades[index].isNew == undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " class="btn btn-danger text-white btn-sm" @click="removeGrade(index)">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="grades.length">
                            <td v-if="showLocalGrades" colspan="7" style="text-align: end;">
                                <strong v-if="selectedProgramCode == 'DBA' || program1Type == 'CAP Program'">Total SBS
                                    Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{ totalCreditsProgram1 }}
                            </td>
                            <td v-else colspan="6" style="text-align: end;">
                                <strong v-if="selectedProgramCode == 'DBA' || program1Type == 'CAP Program'">Total SBS
                                    Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{ totalCreditsProgram1 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead v-if="secondaryGrades.length">
                        <tr v-if="secondaryGrades.length" class="bg-light text-center">
                            <td colspan="9">
                                <h5>
                                    {{ $t("form.student.secondaryGrades") }}
                                </h5>
                            </td>
                        </tr>
                        <tr>
                            <th>{{ $t("form.student.course") }}</th>
                            <th>{{ $t("form.student.percentage") }}</th>
                            <th v-if="showSecondaryLocalGrades" style="min-width: 90px">{{ localGradeLabel }}</th>
                            <th style="min-width: 90px">{{ $t("form.student.grade") }}</th>
                            <th>{{ $t("form.student.descGrade") }}</th>
                            <th>{{ $t("form.student.finalExam") }}</th>
                            <th v-if="selectedProgram2Code == 'DBA' || program2Type == 'CAP Program'">{{
                                $t("form.student.sbsCredits") }}</th>
                            <th v-else>{{ $t("form.student.ectsCredits") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">{{ $t("form.student.enroll") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">{{ $t("form.student.deductibleCredits") }}</th>
                            <th>{{ $t("form.student.action") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(line, index) in $v.secondaryGrades.$each
                            .$iter" v-bind:key="index">
                            <td>{{ secondaryGrades[index].FullTitle }}</td>
                            <td>
                                <div class="form-group">
                                    <input :readonly="secondaryGrades[index].isNew ==
                                        undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " @keyup="
                                            applyGradingScale(
                                                secondaryGrades[index],
                                                'se'
                                            )
                                            " type="text" class="form-control" v-model.trim="line.Percentage.$model"
                                        :class="{
                                            'is-invalid':
                                                line.Percentage.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.Percentage.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.Percentage.$params
                                                    .between.min,
                                                num2: line.Percentage.$params
                                                    .between.max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td v-if="showSecondaryLocalGrades">
                                <div class="form-group">
                                    <input :readonly="secondaryGrades[index].isNew ==
                                        undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " type="text" class="form-control"
                                        @keyup="applyFinalExam(grades[index], partnerCode, check)"
                                        v-model.trim="line.LocalGrade.$model" :class="{
                                            'is-invalid':
                                                line.LocalGrade.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.LocalGrade.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.LocalGrade.$params
                                                    .between.min,
                                                num2: line.LocalGrade.$params
                                                    .between.max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <input :readonly="secondaryGrades[index].isNew ==
                                        undefined &&
                                        isPartnerSchoolUserWithAddGradePermission
                                        " type="text" class="form-control" @keyup="calculateGPA()"
                                        v-model.trim="line.Grade.$model" :class="{
                                            'is-invalid': line.Grade.$error,
                                        }" />
                                    <div class="invalid-feedback" v-if="!line.Grade.between">
                                        {{
                                            $t("form.validation.between", {
                                                num1: line.Grade.$params.between
                                                    .min,
                                                num2: line.Grade.$params.between
                                                    .max,
                                            })
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <select :disabled="secondaryGrades[index].isNew ==
                                    undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " v-model="secondaryGrades[index].DescriptiveGrade
                                        " class="form-control">
                                    <option v-for="(
descriptiveGrade, index
                                        ) in descriptiveGrades" v-bind:key="index" :value="descriptiveGrade">
                                        {{ descriptiveGrade }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <date-picker class="date-picker" :lang="lang" :disabled="secondaryGrades[index].isNew ==
                                    undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " v-model="secondaryGrades[index].FinalExameDate
                                        " valueType="format" :format="dateFormat"
                                    :popup-style="{ top: '100%', left: 0 }" :append-to-body="false">
                                </date-picker>
                            </td>
                            <td v-if="selectedProgram2Code == 'DBA' || program2Type == 'CAP Program'">
                                <input disabled type="text" class="form-control"
                                    :value="secondaryGrades[index].isNew ? secondaryGrades[index].ECTSCredits : getSBSCreditsProgram2(secondaryGrades[index].FullTitle)" />
                            </td>
                            <td v-else>
                                <input disabled type="text" class="form-control"
                                    :value="secondaryGrades[index].isNew ? secondaryGrades[index].ECTSCredits : getECTSCreditsProgram2(secondaryGrades[index].FullTitle)" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                                <input :disabled="secondaryGrades[index].isNew ==
                                    undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " type="checkbox" v-model="secondaryGrades[index].Enrolled"
                                    @change="changeCheck($event)" value="0" />
                            </td>
                            <td class="text-center" v-if="userPartnerCode === 'SBS'"><span>-</span></td>
                            <td>
                                <button :disabled="secondaryGrades[index].isNew ==
                                    undefined &&
                                    isPartnerSchoolUserWithAddGradePermission
                                    " type="button" class="btn btn-danger btn-sm text-white"
                                    @click="removeSecondaryGrade(index)">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="secondaryGrades.length">
                            <td v-if="showLocalGrades" colspan="7" style="text-align: end;">
                                <strong v-if="selectedProgram2Code == 'DBA' || program2Type == 'CAP Program'">Total SBS
                                    Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{ totalCreditsProgram2 }}
                            </td>
                            <td v-else colspan="6" style="text-align: end;">
                                <strong v-if="selectedProgram2Code == 'DBA' || program2Type == 'CAP Program'">Total SBS
                                    Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{ totalCreditsProgram2 }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group grades-btns">
                <div class="text-nowrap" v-if="showGradesBtns">
                    <b-button class="mb-3" variant="default" @click="editProgram()" v-if="permissions.editPrograms">
                        {{ $t("button.manageProgram") }}</b-button><br />
                    <b-button variant="default" @click="addProgramCourses()" v-if="permissions.editStudentsGrades">
                        {{ $t("button.addProgramCourses") }}</b-button>
                </div>

                <div class="text-nowrap">
                    <div class="" v-if="fpGrades && fpGrades.length">
                        <span v-show="!calculatedFpGPA" v-if="fpGpa > 0" class="mb-3 gpa-box">{{ $t("form.student.fpGpa") }}
                            <strong>{{ fpGpa }}</strong></span>
                        <span v-show="calculatedFpGPA" v-if="calculatedFpGPA > 0" class="mb-3 gpa-box">{{ $t("form.student.fpGpa") }}
                            <strong>{{ calculatedFpGPA }}</strong></span><br />
                        <span v-show="!calculatedFpLocalGPA" class="gpa-box" v-if="showLocalGrades && fpLocalGpa > 0">{{
                            $t("form.student.fpLocalGpa") }}
                            <strong>{{ fpLocalGpa }}</strong></span>
                        <span v-show="calculatedFpLocalGPA" class="gpa-box" v-if="showLocalGrades && calculatedFpLocalGPA > 0">{{
                            $t("form.student.fpLocalGpa") }}
                            <strong>{{ calculatedFpLocalGPA }}</strong></span>
                    </div><br />
                    <span v-show="!calculatedGPA" v-if="gpa > 0" class="mb-3 gpa-box">{{ $t("form.student.gpa") }}
                        <strong>{{ gpa }}</strong></span>
                    <span v-show="calculatedGPA" v-if="calculatedGPA > 0" class="mb-3 gpa-box">{{ $t("form.student.gpa") }}
                        <strong>{{ calculatedGPA }}</strong></span><br />
                    <span v-show="!calculatedLocalGPA" class="gpa-box"
                        v-if="(showLocalGrades || showSecondaryLocalGrades) && localGpa > 0">{{ $t("form.student.localGpa") }}
                        <strong>{{ localGpa }}</strong></span>
                    <span v-show="calculatedLocalGPA" class="gpa-box"
                        v-if="(showLocalGrades || showSecondaryLocalGrades) && calculatedLocalGPA > 0">{{ $t("form.student.localGpa") }}
                        <strong>{{ calculatedLocalGPA }}</strong></span>
                </div>
            </div>
            <div class="form-group">
                <label>{{ $t("form.student.courseSearch") }}</label>
                <v-select v-if="gradeType == 'pr'" @input="addGrade" label="FullTitle" :options="courses"
                    :reduce="(courses) => courses" :resetOnOptionsChange="true">
                </v-select>
                <v-select v-if="gradeType == 'se'" @input="addGrade" label="FullTitle" :options="courses2"
                    :reduce="(courses2) => courses2" :resetOnOptionsChange="true">
                </v-select>
                <v-select v-if="gradeType == 'fp'" @input="addFPGrade" label="FullTitle" :options="fpCourses"
                    :reduce="(fpCourses) => fpCourses" :resetOnOptionsChange="true">
                </v-select>
            </div>
            <div class="form-group" v-if="studentProgram.Program2ID">
                <label class="radio-inline" v-if="studentProgram.FoundationID">
                    <input type="radio" v-model="gradeType" value="fp" />
                    {{ $t("form.student.foundationGrades") }} </label><br />
                <label class="radio-inline">
                    <input type="radio" v-model="gradeType" value="pr" />
                    {{ $t("form.student.primaryGrades") }} </label><br />
                <label class="radio-inline">
                    <input type="radio" v-model="gradeType" value="se" />
                    {{ $t("form.student.secondaryGrades") }}
                </label>
            </div>
            <div class="form-group" v-if="studentProgram.FoundationID && !studentProgram.Program2ID">
                <label class="radio-inline">
                    <input type="radio" v-model="gradeType" value="fp" />
                    {{ $t("form.student.foundationGrades") }}
                </label><br />
                <label class="radio-inline">
                    <input type="radio" v-model="gradeType" value="pr" />
                    {{ $t("form.student.primaryGrades") }} </label>
            </div>
            <div class="form-group">
                <b-button variant="danger" @click="exportGrades()">
                    <i class="fa fa-download" aria-hidden="true"></i>
                    {{ $t("button.exportPdf") }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import vue2Dropzone from "vue2-dropzone";
import {
    required,
    minLength,
    maxLength,
    between,
    alpha,
    numeric,
    decimal,
    email,
} from "vuelidate/lib/validators";

export default {
    name: "Grades",
    props: {
        isLoading: Boolean,
        readonly: Boolean,
        gradingScale: Object,
        noGradingScale: Boolean,
        secondaryGrades: Array,
        showGradesBtns: Boolean,
        permissions: Object,
        gpa: String,
        fpGpa: String,
        localGpa: String,
        fpLocalGpa: String,
        courses: Array,
        fpCourses: Array,
        fpGrades: Array,
        foundationGrades: Boolean,
        foundationProgram: Object,
        courses2: Array,
        studentProgram: Object,
        editProgram: Function,
        grades: Array,
        student: Object,
        program1Type: String,
        program2Type: String,
        coursesArr: Array,
        courses2Arr: Array,
        isPartnerSchoolUserWithAddGradePermission: Boolean,
        descriptiveGrades: Array,
        dateFormat: String,
        convertDate: Function,
        selectedProgramCode: String,
        selectedProgram2Code: String,
        changeCheck: Function,
        changeCreditCheck: Function,
        showLocalGrades: Boolean,
        showSecondaryLocalGrades: Boolean,
        localGradeLabel: String,
        localMaxGrade: Object,
        localMinGrade: Object,
        localScale: Object,
        partnerCode: Number,
        userPartnerCode: String
    },

    components: {
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            calculatedGPA: this.gpa,
            calculatedFpGPA: this.fpGpa,
            calculatedLocalGPA: this.localGpa,
            calculatedFpLocalGPA: this.fpLocalGpa,
            totalCreditsFP: 0,
            totalCredits1: 0,
            totalCredits2: 0,

            gradeType: "pr",
            check: false,
            fpCheck: false,
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
            },
        };
    },

    computed: {
        totalCreditsFoundationProgram() {
            let total = 0;
            if (this.fpGrades) {
                this.fpGrades.forEach((fpGrade) => {
                    let credits = 0;
                    if (
                        this.foundationProgram.ProgramCode === 'DBA' ||
                        this.foundationProgram.ProgramType === 'CAP Program'
                    ) {
                        credits = fpGrade.isNew ? fpGrade.SBSCredits : this.getSBSCreditsFoundationProgram(fpGrade.FullTitle);
                    } else {
                        credits = fpGrade.isNew ? fpGrade.ECTSCredits : this.getECTSCreditsFoundationProgram(fpGrade.FullTitle);
                    }
                    total += Number(credits) || 0;
                });
            }
            return total;
        },

        totalCreditsProgram1() {
            let total = 0;
            if (this.grades) {
                this.grades.forEach((grade) => {
                    let credits = 0;
                    if (this.selectedProgramCode === 'DBA' || this.program1Type === 'CAP Program') {
                        credits = grade.isNew ? grade.SBSCredits : this.getSBSCreditsProgram1(grade.FullTitle);
                    } else {
                        credits = grade.isNew ? grade.ECTSCredits : this.getECTSCreditsProgram1(grade.FullTitle);
                    }
                    total += Number(credits) || 0;
                });
            }
            return total;
        },

        totalCreditsProgram2() {
            let total = 0;
            if (this.secondaryGrades) {
                this.secondaryGrades.forEach((grade) => {
                    let credits = 0;
                    if (this.selectedProgram2Code === 'DBA' || this.program2Type === 'CAP Program') {
                        credits = grade.isNew ? grade.SBSCredits : this.getSBSCreditsProgram2(grade.FullTitle);
                    } else {
                        credits = grade.isNew ? grade.ECTSCredits : this.getECTSCreditsProgram2(grade.FullTitle);
                    }
                    total += Number(credits) || 0;
                });
            }
            return total;
        },
    },

    mounted() {
        // Initialize all total credits on page load
        if (this.grades && this.grades.length) {
            this.totalCredits1 = this.calculateTotalCreditsProgram1();
        }
        if (this.secondaryGrades && this.secondaryGrades.length) {
            this.totalCredits2 = this.calculateTotalCreditsProgram2();
        }
        if (this.fpGrades && this.fpGrades.length) {
            this.totalCreditsFP = this.calculateTotalCreditsFoundationProgram();
        }
    },


    methods: {
        /**
         * Add Foundation Program Course to Student Grade's List
         */
        addFPGrade(fpCourse) {
            if (!fpCourse) return;

            const found = this.fpGrades.find(g => g.CourseID === fpCourse.ID);

            if (found) {
                alert(this.$t("form.student.gradeExists"));
                return;
            }

            let fpGrades = {
                CourseID: fpCourse.ID,
                FullTitle: `${fpCourse.CourseCode} - ${fpCourse.CourseTitle}`,
                Percentage: null,
                Grade: null,
                LocalGrade: null,
                DescriptiveGrade: null,
                ECTSGrade: null,
                FinalExameDate: null,
                Enrolled: 0,
                isNew: true,
                SBSCredits: fpCourse.SBSCredits || null,
                ECTSCredits: fpCourse.ECTSCredits || null,
            };

            if (this.foundationProgram.ProgramCode === 'DBA' || this.foundationProgram.ProgramType === 'CAP Program') {
                this.$set(fpGrades, 'SBSCredits', fpCourse.SBSCredits);
            } else {
                this.$set(fpGrades, 'ECTSCredits', fpCourse.ECTSCredits);
            }

            this.fpGrades.push(fpGrades);
        },

        // Return ECTS Credits of primary program
        getECTSCreditsProgram1(fullTitle) {
            const course = this.coursesArr.find(course => fullTitle.includes(course.CourseCode));
            return course ? course.ECTSCredits : null;
        },

        // Return ECTS Credits of Foundation program
        getECTSCreditsFoundationProgram(fullTitle) {
            if (this.fpCourses) {
                const fpCourse = this.fpCourses.find(fpCourse => fullTitle.includes(fpCourse.CourseCode));
                return fpCourse ? fpCourse.ECTSCredits : null;
            }
        },

        // Return SBS Credits of primary program
        getSBSCreditsProgram1(fullTitle) {
            const course = this.coursesArr.find(course => fullTitle.includes(course.CourseCode));
            return course ? course.SBSCredits : null;
        },

        // Return SBS Credits of Foundation program
        getSBSCreditsFoundationProgram(fullTitle) {
            if (this.fpCourses) {
                const fpCourse = this.fpCourses.find(fpCourse => fullTitle.includes(fpCourse.CourseCode));
                return fpCourse ? fpCourse.SBSCredits : null;
            }
        },

        // Return ECTS Credits of secondary program
        getECTSCreditsProgram2(fullTitle) {
            const course = this.courses2Arr.find(course => fullTitle.includes(course.CourseCode));
            return course ? course.ECTSCredits : null;
        },

        // Return SBS Credits of secondary program
        getSBSCreditsProgram2(fullTitle) {
            const course = this.courses2Arr.find(course => fullTitle.includes(course.CourseCode));
            return course ? course.SBSCredits : null;
        },

        // Calculate the total credits based on the primary program type
        calculateTotalCreditsProgram1() {
            let total = 0;

            this.grades.forEach((grade) => {
                if (this.selectedProgramCode === 'DBA' || this.program1Type === 'CAP Program') {
                    // Add SBS credits
                    total += this.getSBSCreditsProgram1(grade.FullTitle);
                } else {
                    // Add ECTS credits
                    total += this.getECTSCreditsProgram1(grade.FullTitle);
                }
            });

            return total;
        },

        // Calculate the total credits based on the foundation program type
        calculateTotalCreditsFoundationProgram() {
            let total = 0;

            if (this.fpGrades) {
                this.fpGrades.forEach((fpGrade) => {
                    if (this.foundationProgram.ProgramCode === 'DBA' || this.foundationProgram.ProgramType === 'CAP Program') {
                        // Add SBS credits
                        total += this.getSBSCreditsFoundationProgram(fpGrade.FullTitle);
                    } else {
                        // Add ECTS credits
                        total += this.getECTSCreditsFoundationProgram(fpGrade.FullTitle);
                    }
                });
            }

            return total;
        },

        // Calculate the total credits based on the secondary program type
        calculateTotalCreditsProgram2() {
            let total = 0;

            this.secondaryGrades.forEach((grade) => {
                if (this.selectedProgram2Code === 'DBA' || this.program2Type === 'CAP Program') {
                    // Add SBS credits
                    total += this.getSBSCreditsProgram2(grade.FullTitle);
                } else {
                    // Add ECTS credits
                    total += this.getECTSCreditsProgram2(grade.FullTitle);
                }
            });

            return total;
        },

        /**
         * Add available program's courses to student grades
         */
        addProgramCourses() {
            // count how many coureses needs to insert into student grades
            let count = 0;

            this.courses.forEach((c) => {
                let found = this.grades.find((g) => g.CourseID == c.ID);

                if (!found) count++;
            });

            if (count == 0) {
                alert(this.$t("form.student.alreadyAssigned"));
                return;
            }

            let conf = confirm(
                this.$t("form.student.coursesCount", {
                    count: count,
                })
            );

            if (conf) {
                this.courses.forEach((c) => {
                    let found = this.grades.find((g) => g.CourseID == c.ID);

                    if (!found) this.addGrade(c);
                });
            }
        },

        /**
         * Add Course to Student Grade's List
         */
        addGrade(course) {
            if (!course) return;

            const found = this.gradeType === "pr" ? this.grades.find(g => g.CourseID === course.ID) : this.secondaryGrades.find(g => g.CourseID === course.ID);

            if (found) {
                alert(this.$t("form.student.gradeExists"));
                return;
            }

            let grade = {
                CourseID: course.ID,
                FullTitle: `${course.CourseCode} - ${course.CourseTitle}`,
                Percentage: null,
                Grade: null,
                LocalGrade: null,
                DescriptiveGrade: null,
                ECTSGrade: null,
                FinalExameDate: null,
                Enrolled: 0,
                isNew: true,
                SBSCredits: course.SBSCredits || null,
                ECTSCredits: course.ECTSCredits || null,
            };

            if (this.selectedProgramCode == 'DBA' || this.program1Type == 'CAP Program') {
                this.$set(grade, 'SBSCredits', course.SBSCredits);
            } else {
                this.$set(grade, 'ECTSCredits', course.ECTSCredits);
            }

            if (this.selectedProgram2Code == 'DBA' || this.program2Type == 'CAP Program') {
                this.$set(grade, 'SBSCredits', course.SBSCredits);
            } else {
                this.$set(grade, 'ECTSCredits', course.ECTSCredits);
            }

            if (this.gradeType === "pr") {
                this.grades.push(grade);
            } else {
                this.secondaryGrades.push(grade);
            }
        },

        applyFinalExam(grade, isSBS, check) {
            if (grade.FinalExameDate == null) {
                grade.FinalExameDate = grade.FinalExameDate
                    ? grade.FinalExameDate
                    : moment().format(this.dateFormat);
            }

            if (grade.Percentage == null && grade.Grade == null && grade.DescriptiveGrade == null && grade.LocalGrade != null && parseFloat(grade.LocalGrade) < 4.0 && isSBS != -1 && !check) {
                grade.DescriptiveGrade = "F";
            }

            this.calculateLocalGPA();
        },

        applyFpFinalExam(fpGrade, isSBS, fpCheck) {
            if (fpGrade.FinalExameDate == null) {
                fpGrade.FinalExameDate = fpGrade.FinalExameDate
                    ? fpGrade.FinalExameDate
                    : moment().format(this.dateFormat);
            }

            if (fpGrade.Percentage == null && fpGrade.Grade == null && fpGrade.DescriptiveGrade == null && fpGrade.LocalGrade != null && parseFloat(fpGrade.LocalGrade) < 4.0 && isSBS != -1 && !fpCheck) {
                fpGrade.DescriptiveGrade = "F";
            }

            this.calculateFpLocalGPA();
        },

        /**
         * Remove Foundation Program Course from Student Grade's List
         */
        removeFpGrade(index) {
            this.fpGrades.splice(index, 1);
            this.calculateFpGPA();
            this.calculateFpLocalGPA();
        },

        /**
         * Remove Course from Student Grade's List
         */
        removeGrade(index) {
            this.grades.splice(index, 1);
            this.calculateGPA();
            this.calculateLocalGPA();
        },

        /**
         * Remove Course from Student Secondary Grade's List
         */
        removeSecondaryGrade(index) {
            this.secondaryGrades.splice(index, 1);
            this.calculateGPA();
            this.calculateLocalGPA();
        },

        /**
         * Calculate Descriptive grades, grades and ECTS grades
         */
        applyGradingScale(grade, type = "pr") {

            const programCode = type == "pr" ? this.selectedProgramCode : this.selectedProgram2Code;
    
            // Guard with detailed logging
            if (!this.gradingScale || !programCode || !this.gradingScale[programCode]) {
                console.warn('Grading scale not ready:', {
                    programCode,
                    gradingScaleExists: !!this.gradingScale,
                    gradingScaleForProgram: this.gradingScale?.[programCode],
                    availablePrograms: this.gradingScale ? Object.keys(this.gradingScale) : []
                });
                
                const errorMessage = this.$t("form.student.noGradingScale", {
                    code: programCode,
                });
                
                this.$emit("noGradingScale", errorMessage);
                return;
            }
            
            let gs = this.gradingScale[programCode];

            let noGradingScale = false;

            if (!gs) {
                this.$emit("noGradingScale", this.$t("form.student.noGradingScale", {
                    code: this.selectedProgramCode,
                }));
                noGradingScale = this.$t("form.student.noGradingScale", {
                    code: this.selectedProgramCode,
                });
                return;
            }

            grade.FinalExameDate = grade.FinalExameDate
                ? grade.FinalExameDate
                : moment().format(this.dateFormat);

            if (!this.showLocalGrades) {
                gs.forEach((item) => {
                    let min = parseFloat(item.minPercentage);
                    let max = parseFloat(item.maxPercentage);
                    let percentage = parseFloat(grade.Percentage);

                    if (percentage >= min && percentage <= max) {
                        this.$set(grade, 'Grade', parseFloat(item.grade));
                        this.$set(grade, 'DescriptiveGrade', item.descGrade);
                    }
                });
            }

            if (this.showLocalGrades || this.showSecondaryLocalGrades) {

                let lgs = this.localScale.grading_scale;

                lgs.forEach((item) => {
                    let min = parseFloat(item.minPercentage);
                    let max = parseFloat(item.maxPercentage);
                    let percentage = parseFloat(grade.Percentage);

                    if (percentage >= min && percentage <= max) {
                        this.$set(grade, 'LocalGrade', parseFloat(item.grade).toFixed(2));
                    }
                });
            }

            this.calculateGPA();
            this.calculateLocalGPA();
            this.$emit("noGradingScale", noGradingScale);
        },

        /**
         * Calculate Foundation Program Descriptive grades, grades and ECTS grades
         */
        applyFpGradingScale(fpGrade, type = "fp") {

            const programCode = this.foundationProgram?.ProgramCode;

            // Guard with detailed logging
            if (!this.gradingScale || !programCode || !this.gradingScale[programCode]) {
                console.warn('Foundation grading scale not ready:', {
                    programCode,
                    gradingScaleExists: !!this.gradingScale,
                    gradingScaleForProgram: this.gradingScale?.[programCode],
                    availablePrograms: this.gradingScale ? Object.keys(this.gradingScale) : []
                });
                
                const errorMessage = this.$t("form.student.noGradingScale", {
                    code: programCode,
                });
                
                this.$emit("noGradingScale", errorMessage);
                return;
            }

            let gs = this.gradingScale[programCode];

            let noGradingScale = false;

            if (!gs) {
                this.$emit("noGradingScale", this.$t("form.student.noGradingScale", {
                    code: this.foundationProgram.ProgramCode,
                }));
                noGradingScale = this.$t("form.student.noGradingScale", {
                    code: this.foundationProgram.ProgramCode,
                });
                return;
            }

            fpGrade.FinalExameDate = fpGrade.FinalExameDate
                ? fpGrade.FinalExameDate
                : moment().format(this.dateFormat);

            if (!this.showLocalGrades) {
                gs.forEach((item) => {
                    let min = parseFloat(item.minPercentage);
                    let max = parseFloat(item.maxPercentage);
                    let percentage = parseFloat(fpGrade.Percentage);

                    if (percentage >= min && percentage <= max) {
                        this.$set(fpGrade, 'Grade', parseFloat(item.grade));
                        this.$set(fpGrade, 'DescriptiveGrade', item.descGrade);
                    }
                });
            }

            if (this.showLocalGrades) {

                if (!this.localScale || !this.localScale.grading_scale) {
                    console.warn('Local scale not available for foundation program');
                } else {
                    let lgs = this.localScale.grading_scale;

                    lgs.forEach((item) => {
                        let min = parseFloat(item.minPercentage);
                        let max = parseFloat(item.maxPercentage);
                        let percentage = parseFloat(fpGrade.Percentage);

                        if (percentage >= min && percentage <= max) {
                            this.$set(fpGrade, 'LocalGrade', parseFloat(item.grade).toFixed(2));
                        }
                    });
                }
            }

            this.calculateFpGPA();
            this.calculateFpLocalGPA();
            this.$emit("noGradingScale", noGradingScale);
        },

        calculateGPA() {

            axios
                .post("/api/students/calculate-gpa", {
                    grades: this.grades,
                    secondaryGrades: this.secondaryGrades,
                    courses: this.courses,
                    courses2: this.courses2,
                    selectedProgramCode: this.selectedProgramCode,
                    selectedProgram2Code: this.selectedProgram2Code,
                    programId: this.studentProgram.ProgramID,
                    program2Id: this.studentProgram.Program2ID
                })
                .then((response) => {
                    this.calculatedGPA = response.data.gpa;
                })
                .catch((error) => console.log("error"));
        },

        calculateFpGPA() {

            axios
                .post("/api/students/calculate-fp-gpa", {
                    fpGrades: this.fpGrades,
                    fpCourses: this.fpCourses,
                    selectedProgramCode: this.foundationProgram.ProgramCode,
                    programId: this.foundationProgram.ID
                })
                .then((response) => {
                    this.calculatedFpGPA = response.data.gpa;
                })
                .catch((error) => console.log("error"));
        },

        calculateLocalGPA() {

            axios
                .post("/api/students/calculate-local-gpa", {
                    grades: this.grades,
                    secondaryGrades: this.secondaryGrades,
                    courses: this.courses,
                    courses2: this.courses2,
                    selectedProgramCode: this.selectedProgramCode,
                    selectedProgram2Code: this.selectedProgram2Code,
                    programId: this.studentProgram.ProgramID,
                    program2Id: this.studentProgram.Program2ID
                })
                .then((response) => {
                    this.calculatedLocalGPA = response.data.local_gpa;
                    this.check = response.data.check; // true if program is dba or CAP

                })
                .catch((error) => console.log("error"));
        },

        calculateFpLocalGPA() {

            axios
                .post("/api/students/calculate-fp-local-gpa", {
                    fpGrades: this.fpGrades,
                    fpCourses: this.fpCourses,
                    selectedProgramCode: this.foundationProgram.ProgramCode,
                    programId: this.foundationProgram.ID,
                })
                .then((response) => {
                    this.calculatedFpLocalGPA = response.data.local_gpa;
                    this.fpCheck = response.data.check; // true if program is dba or CAP

                })
                .catch((error) => console.log("error"));
        },

        async createToken(type) {
            let response = await axios.post("/api/api-tokens", {
                type,
            });
            let token = "";

            if (response.status == 200) {
                token = response.data.extra[0].token;
            }

            return token;
        },

        /*
            Export Grades
        */
        async exportGrades() {
            let token = await this.createToken("student-grades");

            if (token == "") return;

            let url = `/students/${this.student.ID}/grades?token=${token}`;

            window.open(url, "_blank");
        },
    },
    validations: {
        grades: {
            $each: {
                Percentage: {
                    between: between(0, 100),
                },
                Grade: {
                    between: between(0, 4),
                },
                LocalGrade: {
                    between: between(0, 6),
                },
            },
        },

        fpGrades: {
            $each: {
                Percentage: {
                    between: between(0, 100),
                },
                Grade: {
                    between: between(0, 4),
                },
                LocalGrade: {
                    between: between(0, 6),
                },
            },
        },

        secondaryGrades: {
            $each: {
                Percentage: {
                    between: between(0, 100),
                },
                Grade: {
                    between: between(0, 4),
                },
                LocalGrade: {
                    between: between(0, 6),
                },
            },
        },
    },
};
</script>

<style scoped>
::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: black !important;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: black !important;
}

:-ms-input-placeholder {
    /* IE 10+ */
    color: black !important;
}

:-moz-placeholder {
    /* Firefox 18- */
    color: black !important;
}

body {
    background-color: #e2e2e2;
}

.overlay-row {
    cursor: not-allowed;
    background: #eee;
}

input[type="date"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
}

.custom-validate {
    display: block !important;
}

.grades-btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 5px;
    background-color: #fff;
    padding: 2rem;
}

.grades-btns button,
.gpa-box {
    min-width: 150px;
    text-align: center;
}

.gpa-box {
    display: inline-block;
    font-size: 110%;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0.35rem;
    margin-top: 1rem;
}

@media only screen and (min-width: 1900px) {
    .grades-btns {
        flex-direction: row;
        justify-content: space-between;
    }

    .gpa-box {
        text-align: center;
        padding: 2rem;
        margin-top: 0;
    }
}
</style>